module.exports = __webpack_public_path__ + "static/media/trave mall shot 4.3d23ba87.webp";